export default __webpack_public_path__ + "static/media/japanese-food.92f0adac.png";